/*
 * @Description: 页面描述
 * @Author: MR.小涛
 * @Date: 2018-12-24 20:23:30
 * @LastEditors: MR.小涛
 * @LastEditTime: 2019-09-22 11:17:02
 */
import Vue from 'vue'
import Router from 'vue-router'
// 登录
const login = () =>
    import('@/components/login')
    // 导航加载头部加载
const home = () =>
    import('@/components/home')
    // 学生管理
const studentManagement = () =>
    import('@/views/students/student-management')
    // 增加学生
const addStudents = () =>
    import('@/views/students/add-students')
    // 学生详情
const studentDetails = () =>
    import('@/views/students/student-details')
    // 老师管理
const teacherManagement = () =>
    import('@/views/teachers/teacher-management')
    // 添加老师
const detailsTeacher = () =>
    import('@/views/teachers/details-teacher')
    // 添加老师
const addBusTeacher = () =>
    import('@/views/teachers/add-busTeacher')
    // 校车管理
const SchoolBusManagement = () =>
    import('@/views/schoolbus/SchoolBus-management')
    // 添加校车
const addingSchoolBus = () =>
    import('@/views/schoolbus/adding-schoolBus')
    // 校车详情
const SchoolBusManagementDetails = () =>
    import('@/views/schoolbus/Schoolbus-management-details')
    // 站点管理
const siteManagement = () =>
    import('@/views/site/site-management')
    // 添加站点
const addSite = () =>
    import('@/views/site/add-site')
    // 路线管理
const routeManagement = () =>
    import('@/views/routeManagement/route-management')
    // 路线管理添加
const addingRouteManagement = () =>
    import('@/views/routeManagement/adding-routeManagement')
    // 路线监控
const realTimeMonitoring = () =>
    import('@/views/route-monitoring/real-timeMonitoring')
    // 日历设置
const calendarManagement = () =>
    import('@/views/calendar-Management/calendar-Management')
    // 历史数据
const historicalRecord = () =>
    import('@/views/route-monitoring/historical-record')
const welcome = () =>
    import('@/views/base/welcome')
    // 学生乘车记录
const reportSutdent = () =>
    import('@/views/report/report-sutdent')
    // 高级查询
const advancedQuery = () =>
    import('@/views/report/advanced-query')
    // 学生乘车记录 详情
const reportStudentDetails = () =>
    import('@/views/report/report-student-details')
const recordOfStudentLeave = () =>
    import('@/views/report/record-of-student-leave')
const recordOfTeacherSign = () =>
    import('@/views/report/record-of-teacher-signin')
const reportHealthCode = () =>
    import('@/views/report/health-code')
const reportJourOnTime = () =>
  import('@/views/report/report-jour-onTime-Rate')
const reportJourStopOnTime = () =>
  import('@/views/report/report-jour-stop-onTime-details')
// 修改密码
const editPassword = () =>
    import('@/components/edit-password')

const Notice = () =>
    import('@/views/notice-msg/notice')

const NoticeDetail = () =>
    import('@/views/notice-msg/notice_detail')

const Msg = () =>
    import('@/views/notice-msg/msg')

const MsgRecord = () =>
    import('@/views/notice-msg/msg_record')

Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'login',
    component: login
  },
  {
    path: '/noticedetail',
    name: 'noticedetail',
    component: NoticeDetail
  },
  {
    path: '/home',
    component: home,
    meta: {
      title: '首页',
      requiresAuth: true
    },
    children: [{
      path: '',
      name: 'welcome',
      component: welcome,
      meta: {
        pullPath: '/home/welcome'
      }
    },
    {
      path: 'studentManagement',
      name: 'studentManagement',
      component: studentManagement,
      meta: {
        metaArr: ['系统管理', '学生管理'],
        pullPath: '/home/studentManagement',
        keepAlive: true
      }
    },
    {
      path: 'addStudents',
      name: 'addStudents',
      component: addStudents,
      meta: {
        metaArr: ['系统管理', '学生管理', '添加学生'],
        pullPath: '/home/studentManagement'
      }
    },
    {
      path: 'studentDetails',
      name: 'studentDetails',
      component: studentDetails,
      meta: {
        metaArr: ['系统管理', '学生管理', '学生详情'],
        pullPath: '/home/studentManagement'
      }
    },
    {
      path: 'teacherManagement',
      name: 'teacherManagement',
      component: teacherManagement,
      meta: {
        metaArr: ['系统管理', '老师管理'],
        pullPath: '/home/teacherManagement',
        keepAlive: true
      }
    },
    {
      path: 'addBusTeacher',
      name: 'addBusTeacher',
      component: addBusTeacher,
      meta: {
        metaArr: ['系统管理', '老师管理', '添加老师'],
        pullPath: '/home/teacherManagement'
      }
    },
    {
      path: 'detailsTeacher',
      name: 'detailsTeacher',
      component: detailsTeacher,
      meta: {
        metaArr: ['系统管理', '老师管理', '老师详情'],
        pullPath: '/home/teacherManagement'
      }
    },
    {
      path: 'SchoolBusManagement',
      name: 'SchoolBusManagement',
      component: SchoolBusManagement,
      meta: {
        metaArr: ['系统管理', '校车管理'],
        pullPath: '/home/SchoolBusManagement',
        keepAlive: true
      }
    },
    {
      path: 'addingSchoolBus',
      name: 'addingSchoolBus',
      component: addingSchoolBus,
      meta: {
        metaArr: ['系统管理', '校车管理', '添加校车'],
        pullPath: '/home/SchoolBusManagement'
      }
    },
    {
      path: 'SchoolBusManagementDetails',
      name: 'SchoolBusManagementDetails',
      component: SchoolBusManagementDetails,
      meta: {
        metaArr: ['系统管理', '校车管理', '校车详情'],
        pullPath: '/home/SchoolBusManagement'
      }
    },
    {
      path: 'siteManagement',
      name: 'siteManagement',
      component: siteManagement,
      meta: {
        metaArr: ['系统管理', '站点管理'],
        pullPath: '/home/siteManagement',
        keepAlive: true
      }
    },
    {
      path: 'addSite',
      name: 'addSite',
      component: addSite,
      meta: {
        metaArr: ['系统管理', '站点管理', '添加站点'],
        pullPath: '/home/siteManagement'
      }
    },
    {
      path: 'routeManagement',
      name: 'routeManagement',
      component: routeManagement,
      meta: {
        metaArr: ['系统管理', '路线管理'],
        pullPath: '/home/routeManagement',
        keepAlive: true
      }
    },
    {
      path: 'addingRouteManagement',
      name: 'addingRouteManagement',
      component: addingRouteManagement,
      meta: {
        metaArr: ['系统管理', '添加路线'],
        pullPath: '/home/routeManagement'
      }
    },
    {
      path: 'realTimeMonitoring',
      name: 'realTimeMonitoring',
      component: realTimeMonitoring,
      meta: {
        metaArr: ['路线监控', '实时监控'],
        pullPath: '/home/realTimeMonitoring'
      }
    },
    {
      path: 'historicalRecord',
      name: 'historicalRecord',
      component: historicalRecord,
      meta: {
        metaArr: ['路线监控', '历史数据'],
        pullPath: '/home/historicalRecord'
      }
    },
    {
      path: 'calendarManagement',
      name: 'calendarManagement',
      component: calendarManagement,
      meta: {
        metaArr: ['系统管理', '日历管理'],
        pullPath: '/home/calendarManagement'
      }
    },
    {
      path: 'reportSutdent',
      name: 'reportSutdent',
      component: reportSutdent,
      meta: {
        metaArr: ['报告', '学生乘车记录'],
        pullPath: '/home/reportSutdent',
        keepAlive: true // 此组件需要被缓存
      }
    },
    {
      path: 'advancedQuery',
      name: 'advancedQuery',
      component: advancedQuery,
      meta: {
        metaArr: ['报告', '学生乘车记录', '高级查询'],
        pullPath: '/home/reportSutdent'
      }
    },
    {
      path: 'reportStudentDetails',
      name: 'reportStudentDetails',
      component: reportStudentDetails,
      meta: {
        metaArr: ['报告', '学生乘车记录', '详情'],
        pullPath: '/home/reportSutdent'
      }
    },
    {
      path: 'recordOfStudentLeave',
      name: 'recordOfStudentLeave',
      component: recordOfStudentLeave,
      meta: {
        metaArr: ['报告', '学生请假记录', '今日'],
        pullPath: '/home/recordOfStudentLeave'
      }
    },
    {
      path: 'recordOfTeacherSign',
      name: 'recordOfTeacherSign',
      component: recordOfTeacherSign,
      meta: {
        metaArr: ['报告', '老师签到记录'],
        pullPath: '/home/recordOfTeacherSign'
      }
    },
    {
      path: 'reportHealthCode',
      name: 'reportHealthCode',
      component: reportHealthCode,
      meta: {
        metaArr: ['报告', '学生健康码'],
        pullPath: '/home/reportHealthCode'
      }
    },
    {
      path: 'reportJourOnTime',
      name: 'reportJourOnTime',
      component: reportJourOnTime,
      meta: {
        metaArr: ['报告', '校车准点记录'],
        pullPath: '/home/reportJourOnTime'
      }
    },
    {
      path: 'reportJourStopOnTime',
      name: 'reportJourStopOnTime',
      component: reportJourStopOnTime,
      meta: {
        metaArr: ['报告', '校车准点记录', '详情'],
        pullPath: '/home/reportJourStopOnTime'
      }
    },
    {
      path: 'editPassword',
      name: 'editPassword',
      component: editPassword,
      meta: {
        metaArr: ['设置'],
        pullPath: '/home/editPassword'
      }
    },
    {
      path: 'notice',
      name: 'notice',
      component: Notice,
      meta: {
        metaArr: ['通知与消息', '通知管理'],
        pullPath: '/home/notice'
      }
    },
    {
      path: 'msg',
      name: 'msg',
      component: Msg,
      meta: {
        metaArr: ['通知与消息', '消息模版'],
        pullPath: '/home/msg'
      }
    },
    {
      path: 'msgrecord',
      name: 'msgrecord',
      component: MsgRecord,
      meta: {
        metaArr: ['通知与消息', '消息记录'],
        pullPath: '/home/msgrecord'
      }
    }
    ]
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js